import { axiosHelper } from 'Services/AxiosHelper';
import { InstrunctionListReqModel } from 'Models';
import { InstrunctionListReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'b2c.RIInstructionList';

const getInstructionList = async (params: InstrunctionListReqBodyData): Promise<InstrunctionListReqModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default getInstructionList;
